import React from 'react';
import Plus from '@uber/base-icons/plus';
import { useStyletron } from 'baseui';
import { Button, KIND as BUTTON_KIND, SIZE as BUTTON_SIZE } from 'baseui/button';
import { ListItem } from 'baseui/list';
import { LabelLarge } from 'baseui/typography';
import { RELATIONSHIP_CREATOR_CONSTANTS } from '../constants';
type CreateRelationshipButtonProps = {
  disabled?: boolean;
  label?: React.ReactNode;
  onClick?: () => void;
  variant?: 'button' | 'list';
};
const CREATE_BUTTON_OVERRIDES = {
  Root: {
    style: ({
      $theme
    }) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      padding: `${$theme.sizing.scale700} 0`,
      borderTop: `1px solid ${$theme.colors.borderTransparent}`,
      cursor: 'pointer'
    })
  },
  Content: {
    style: {
      borderBottom: 'none',
      padding: '0',
      margin: '0',
      minHeight: 'auto'
    }
  }
};
export const CreateRelationshipButton = ({
  disabled,
  label = RELATIONSHIP_CREATOR_CONSTANTS.CREATE_BUTTON,
  onClick,
  variant = 'list'
}: CreateRelationshipButtonProps) => {
  const [, theme] = useStyletron();
  if (variant === 'button') {
    return <Button kind={BUTTON_KIND.secondary} size={BUTTON_SIZE.small} endEnhancer={<Plus size={12} />} disabled={disabled} onClick={onClick}>
        {label}
      </Button>;
  }
  return <ListItem endEnhancer={() => <Plus size={18} color={theme.colors.contentPrimary} />} onClick={disabled ? undefined : onClick} overrides={CREATE_BUTTON_OVERRIDES}>
      <LabelLarge>{label}</LabelLarge>
    </ListItem>;
};